<template>
  <b-container v-if="this.type">
    <h1 v-translate="{type: $appConfig.models[this.type].title}">Edit %{type}</h1>
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        <translate>The Country has been updated</translate>
      </b-alert>
      <b-row>
        <b-col cols="8">
          <b-form @submit.prevent="patchCountry">
            <div
              :id="'fieldsetHorizontal' + index"
              v-for="(field, index) in fields"
              :key="index"
            >
              <b-form-row
                class="mb-3"
                v-if="field.type !== Array"
              >
                <b-col sm="4" lg="3">
                  <label id="fieldsetHorizontal__BV_label_" :for="'inputHorizontal'+ index" class="col-form-label">{{field.label || snakeCaseToTitleCase(field.key)}}<small class="text-danger" v-if="field.required"> *</small></label>
                </b-col>
                <b-col>
                  <b-form-select v-model="country[field.key]" :options="[{value: 1, text: $gettext('Yes')}, {value: 0, text: $gettext('No')}]" :key="index" v-if="field.type === Boolean" :disabled="!field.editable || (field.editCondition && !field.editCondition(country))" />
                  <b-form-select v-model="country[field.key]" :options="setFieldOptions(field.options, field.withSelect)" class="mb-3" v-else-if="field.type === 'select' && initialized" :disabled="!field.editable || (field.editCondition && !field.editCondition(country))">
                  </b-form-select>
                  <v-jsoneditor :height="'500px'" v-model="country[field.key]" v-else-if="field.type === 'JSON'" :key="'json-' + index" :options="{modes: ['tree', 'view', 'form', 'code', 'text', 'preview'], mode: 'code'}"></v-jsoneditor>
                  <span v-else-if="field.type === 'link'"><a :href="country[field.key]" target="_blank">{{country[field.key]}}</a></span>
                  <b-form-input v-else-if="field.type === 'integer'" :id="'inputHorizontal'+ index" type="number" :step="1" v-model="country[field.key]" :disabled="!field.editable || (field.editCondition && !field.editCondition(country))" :key="'number-' + index" :required="field.required" />
                  <b-form-input :id="'inputHorizontal'+ index" :type="field.type || 'text'" :step="field.type === 'time' && field.step ? field.step : null" v-model="country[field.key]" :disabled="!field.editable || (field.editCondition && !field.editCondition(country))" :key="'general-' + index" :required="field.required" v-else />
                  <small tabindex="-1" class="form-text text-muted" v-if="field.description" v-html="field.description"></small>
                </b-col>
              </b-form-row>
              <b-form-row v-else>
                <label id="fieldsetHorizontal__BV_label_" :for="'inputHorizontal'+ index" class="col-form-label">{{field.label || snakeCaseToTitleCase(field.key)}}<small class="text-danger" v-if="field.required"> *</small></label>
                 <b-form-input v-for="(subcountry, i) in country[field.key]" v-model="country[field.key][i]" :key="i" class="mb-3"></b-form-input>
              </b-form-row>
            </div>
            <b-col>
              <b-button type="submit" variant="primary" v-translate>Submit</b-button>
            </b-col>
            <b-col class="text-right" v-if="this.$appConfig.models[this.type].allowDelete">
              <b-button @click.stop="deleteCountry" variant="danger" v-translate>DELETE Country</b-button>
            </b-col>
          </b-form>
        </b-col>
        <b-col>
          <b-form @submit.prevent="setNotifications">
            <h4 v-translate><span class="text-danger">DISABLE</span> Country Notifications <small>(realtime change)</small></h4>
            <h6 v-translate>Note: Checked means <span class="text-danger">DISABLED</span> and the notification won't go.</h6>
            <div v-for="notificationType in notificationTypes" :key="notificationType.id" class="mb-2">
              <b-form-checkbox
                v-model="notificationsSelected"
                :key="notificationType.id"
                :value="notificationType.id"
                class="cols-12"
                @change="changeNotification(notificationType.id)"
              >
                <strong>{{ notificationType.name }}</strong> ({{notificationType.media_default}})<br>{{notificationType.description}}
              </b-form-checkbox>
            </div>
          </b-form>
        </b-col>
      </b-row>
  </b-container>
</template>
<script>
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  name: 'CountryEdit',
  components: {
    VJsoneditor
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'countries'
    },
    id: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      fields: this.$appConfig.models[this.type].fields,
      country: {},
      success: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      notificationsSelected: []
    }
  },
  watch: {
    type: function (val) {
      this.fields = this.$appConfig.models[this.type].fields
    }
  },
  created() {
    this.fetchNotificationTypes()
  },
  mounted() {
    this.getCountry()
  },
  methods: {
    getCountry() {
      const params = {
        includes: [
          'notification_configs'
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id, {params: params})
        .then(response => {
          this.country = response.body
          this.notificationsSelected = this.country.notification_configs.map((notificationType) => {
            return notificationType.notification_type_id
          })
        })
    },
    patchCountry() {
      let toPatch = {}
      for (let field in this.fields) {
        if (this.fields[field].editable) {
          toPatch[this.fields[field].key] = this.fields[field].key === 'cut_time' ? (this.country[this.fields[field].key].split(':').length < 3 ? this.country[this.fields[field].key] + ':00' : this.country[this.fields[field].key]) : this.country[this.fields[field].key]
        }
        if (this.fields[field].editable && this.fields[field].toLowerCase) {
          toPatch[this.fields[field].key] = toPatch[this.fields[field].key].toLowerCase()
        }
      }

      this.$http.patch(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id, toPatch)
        .then(response => {
          this.showAlert()
          this.getCountry()
        })
    },
    deleteCountry() {
      if (
        confirm(this.$gettextInterpolate(this.$gettext('Are you sure you want to DELETE the row with ID:\n%{id}\nWARNING: THIS ACTION CANNOT BE UNDONE!'), {id: this.id}))
      ) {
        this.$http.delete(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id)
          .then(response => {
            this.$router.push('/list/' + this.$appConfig.models[this.type].endpoint, { query: { deleted: true } })
          })
      }
    },
    changeNotification(notification) {
      this.$nextTick(() => {
        if (this.notificationsSelected.indexOf(notification) !== -1) {
          let payload = {
            country_id: this.country.id,
            notification_type_id: notification,
            enabled: false
          }
          this.$http.post(this.$appConfig.api.baseUrl + 'country-notification-configs', payload)
            .then(response => {
              this.showAlert()
              this.getCountry()
            })
        } else {
          let notificationConfigId = this.country.notification_configs.find(x => x.notification_type_id === notification).id
          this.$http.delete(this.$appConfig.api.baseUrl + 'country-notification-configs/' + notificationConfigId)
            .then(response => {
              this.showAlert()
              this.getCountry()
            })
        }
      })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    snakeCaseToTitleCase(str) {
      return str.replace(/_/g, ' ').replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    }
  }
}
</script>
